import { render, staticRenderFns } from "./limitRulesList.vue?vue&type=template&id=5db50bfc&"
import script from "./limitRulesList.vue?vue&type=script&lang=js&"
export * from "./limitRulesList.vue?vue&type=script&lang=js&"
import style0 from "./limitRulesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports